import moment from 'moment';

export function bootLancamento({ formData, tipo }) {
    const base = formData || {};

    return {
        ...base,
        empresaId: base.empresaId || localStorage.getItem('empresaId'),
        parcela: base.parcela || 1,
        dataLancamento: base.dataLancamento || moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        dataVencimento: base.dataVencimento || moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        tipo: base.tipo || tipo,
        calculaJuros: base.calculaJuros ?? false,
    };
}
